export function RosterSummary({
  seatsTaken,
  playerCap,
  waiting,
}: {
  seatsTaken: number;
  playerCap: number;
  waiting: number;

}) {
  return (
    <dl className="grid grid-cols-2 gap-2">
      <Count label="Players" value={`${seatsTaken}/${playerCap}`} />
      <Count label="Waitlist" value={String(waiting)} />
    </dl>
  );
}

function Count({ label, value, urgent }: { label: string; value: string; urgent?: boolean }) {
  return (
    <div
      className={[
        'rounded-md border px-3.5 py-2.5',
        urgent ? 'border-signal bg-tint-signal' : 'border-light bg-paper',
      ].join(' ')}
    >
      <dt
        className={[
          'text-[11px] font-semibold uppercase tracking-[0.09em]',
          urgent ? 'text-on-tint-signal' : 'text-ink-3',
        ].join(' ')}
      >
        {label}
      </dt>
      <dd
        className={[
          'tabular mt-0.5 text-[19px] leading-none',
          urgent ? 'font-semibold text-on-tint-signal' : '',
        ].join(' ')}
      >
        {value}
      </dd>
    </div>
  );
}
